import { AuthManager } from "features/Authentication/AuthManager"

import { isLocalStorageFlagSet, useUserActivityTracker } from "."

type Prop = {
  learningItemId: string
  learningItemType: string
  learningContentId: string
  learningContentType: string
  userPlannerItemId: string
}

export type LearningActivityTrackerData = {
  learning_item_id: string
  learning_item_type: string
  learning_content_id: string
  learning_content_type: string
  user_planner_item_id: string
  user_id: string
}

const getTimeoutByType = (type?: string): number => {
  if (!type) return 0 // No timeout if type is not defined

  switch (type) {
    case "article":
      return 1000 * 60 * 4 // 4 minutes
    case "video":
    case "pre_recorded_class":
      return 1000 * 60 // 1 minute
    case "assessment_schedule":
    case "assessment":
      return 1000 * 60 * 2 // 2 minutes
    case "discussion":
      return 1000 * 60 * 2 // 2 minutes
    case "assignment":
      return 1000 * 60 * 7 // 7 minutes
    case "activity":
      return 1000 * 60 * 2 // 2 minutes
    // Just handling these for the sake of handling
    case "class":
    case "class_schedule":
      return 1000 * 60 * 2 // 2 minutes
    case "course":
      return 1000 * 60 * 2 // 2 minutes
    default:
      return 0
  }
}

const useLearningActivityTracker = (props: Prop) => {
  const trackingData = {
    learning_item_id: props.learningItemId,
    learning_item_type: props.learningItemType,
    learning_content_id: props.learningContentId,
    learning_content_type: props.learningContentType,
    user_planner_item_id: props.userPlannerItemId,
    user_id: AuthManager.getPlatformAuth()?.user.uuid ?? "",
  }

  const timeout = getTimeoutByType(props.learningContentType)

  useUserActivityTracker({
    id: props.userPlannerItemId || "",
    enabled: Boolean(props.userPlannerItemId && timeout > 0),
    data: trackingData,
    debug: isLocalStorageFlagSet("debug"),
    activityTimeout: timeout,
  })
}

export default useLearningActivityTracker
